import React from 'react';
import Nav from '../components/nav/Nav';
import Footer from '../components/footer/Footer';
import './AboutPage.css'
import aboutImg from '../assets/aboutus/ABOUT-GET-IN-LINE.svg';
import toniaAboutImg from '../assets/aboutus/foto-about-us.png'

function AboutPage() {
    // We use the same container styles as your other pages to keep the footer pinned
    return (
        <div className='page-container'>
            <Nav />
              <div className='about-img'>
                  <img src={aboutImg} alt="About Get In Line" />
              </div>
                <div className='about-row'>
                  <div className='about-image'>
                    <img src={toniaAboutImg} alt="Tonia Founder Get In Line" />
                  </div>
                  <div className='about-text about-page'>
                    <p>
                      Get In Line was born in Barcelona, founded by an Italian girl who has always had a deep passion for fashion. Living in a city that blends cultures, energies, and creativity from all over the world opened my mind and inspired me to transform new ideas into a meaningful, authentic project.
                    </p>
                    <p>
                      From this mix of experiences comes my vision: taking forgotten material sodatabs, bottle caps, and small recycled objects and turning them into one-of-a-kind creations through a completely handcrafted process. Each piece is carefully made by hand, respecting the history of the material and giving it a new, original life.
                    </p>
                    <p>
                      I deeply believe that sustainable fashion is an act of love for the planet and a way to offer my customers something truly special, authentic, and unique. Every item carries subtle characteristics that are not flaws, but marks of its identity details that tell the story of where it comes from and how it was crafted.
                    </p>
                    <p>
                      It’s the art of turning the simple into the extraordinary. It’s an invitation to choose thoughtfully, with care, and with heart.
                    </p>
                  </div>
                </div>
            <Footer />
        </div>
    );
}

export default AboutPage;
